import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'tabLink', 'tabContent' ];

  show(event) {
    event.preventDefault();
    const target = event.target;

    for (let tab of this.tabLinkTargets) {
      tab.classList.remove('active');
    }

    for (let tab of this.tabContentTargets) {
      tab.classList.remove('active');
    }

    target.classList.add('active');
    document.querySelector(target.dataset.country).classList.add('active');

    if (typeof window.machineGlider != 'undefined') {
      for (let glider of window.machineGlider) {
        glider.refresh(true);
      }
    }
  }
}
